/**
 * TreeSelect 搜索过滤：按节点 title 文本做不区分大小写匹配。
 * 用于替代已废弃的 treeNodeFilterProp="title"。
 *
 * @param {string} input 搜索框输入
 * @param {{ title?: string | number }} node 树节点
 */
export function filterTreeNodeByTitle(input, node) {
    const raw = node?.title;
    const text = raw == null ? '' : typeof raw === 'string' || typeof raw === 'number' ? String(raw) : '';
    return text.toLowerCase().includes(String(input ?? '').toLowerCase());
}
